export default __webpack_public_path__ + "static/media/icon-server-delivery.b71dad84.svg";